/**
 * AlertDialog.tsx - Alert dialog component
 * 
 * CHANGE HISTORY:
 * - 251025_1600 [pending] danielbeer: Initial creation
 * 
 * Simple alert dialog with OK button
 */

import React from 'react';
import { Modal } from './Modal';
import { AlertConfig } from '../types';

export interface AlertDialogProps extends AlertConfig {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * AlertDialog - Alert message component
 * 
 * Features:
 * - Single OK button
 * - Type-based theming
 * - Auto-focus on OK button
 */
export const AlertDialog: React.FC<AlertDialogProps> = ({
  isOpen,
  title,
  message,
  type = 'info',
  okText = 'OK',
  onClose
}) => {
  const footer = (
    <button className="btn btn-primary" onClick={onClose} autoFocus>
      {okText}
    </button>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      type={type}
      size="small"
      footer={footer}
    >
      <p style={{ margin: 0, color: 'var(--text-primary)' }}>
        {message}
      </p>
    </Modal>
  );
};
